import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from "@rails/request.js"

// Connects to data-controller="scraper-request"
export default class extends Controller {
  static targets = ['submit', 'input', 'uuid', 'output']
  static values = { url: String }

  connect() {
    // console.log('Scraper Request controller connected')
    this.observeChanges()
    this.inputTarget.addEventListener('input', this.stopLoading.bind(this))
  }

  async submit(e) {
    e.preventDefault()

    const input = this.inputTarget.value
    const uuid = this.uuidTarget.value
    const url = this.urlValue

    if (input.trim() === '') {
      alert('Please enter a input.')
      return
    }

    this.startLoading()

    try {
      const request = new FetchRequest('post', url, {
        body: JSON.stringify({ scraper_request: { scraped_url: input, uuid: uuid, output: this.outputTarget.id } }),
        responseKind: 'turbo-stream'
      })
      await request.perform()
    } catch (error) {
      console.error(error)
      alert('An error occurred. Please try again.')
    }
  }

  startLoading() {
    this.submitTarget.classList.add('loading')
    this.observeChanges() // Re-observe changes when loading starts
  }

  stopLoading() {
    this.submitTarget.classList.remove('loading')
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  observeChanges() {
    const scrapedContent = this.outputTarget

    if (scrapedContent) {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'characterData' || mutation.type === 'childList') {
            this.stopLoading()
          }
        })
      })

      // Observe changes in text content within the textarea
      this.observer.observe(scrapedContent, { characterData: true, childList: true, subtree: true })
    }
  }
}
